export const MEMES_LIST_REQUEST = 'MEMES_LIST_REQUEST';
export const MEMES_LIST_SUCCESS = 'MEMES_LIST_SUCCESS';
export const MEMES_LIST_FAIL = 'MEMES_LIST_FAIL';

export const UPLOAD_MEM_REQUEST = 'UPLOAD_MEM_REQUEST';
export const UPLOAD_MEM_SUCCESS = 'UPLOAD_MEM_SUCCESS';
export const UPLOAD_MEM_FAIL = 'UPLOAD_MEM_FAIL';

export const ACCEPT_OR_DELETE_MEM_REQUEST = 'ACCEPT_OR_DELETE_MEM_REQUEST';
export const ACCEPT_OR_DELETE_MEM_SUCCESS = 'ACCEPT_OR_DELETE_MEM_SUCCESS';
export const ACCEPT_OR_DELETE_MEM_FAIL = 'ACCEPT_OR_DELETE_MEM_FAIL';

export const LIKE_OR_UNLIKE_MEM_REQUEST = 'LIKE_OR_UNLIKE_MEM_REQUEST';
export const LIKE_OR_UNLIKE_MEM_SUCCESS = 'LIKE_OR_UNLIKE_MEM_SUCCESS';
export const LIKE_OR_UNLIKE_MEM_FAIL = 'LIKE_OR_UNLIKE_MEM_FAIL';

export const SET_INIT_STATE = 'SET_INIT_STATE';